module.exports = {
  UNCONFIRMED: {
    key: 'UNCONFIRMED',
    label: 'UNCONFIRMED',
  },
  CONFIRMED: {
    key: 'CONFIRMED',
    label: 'CONFIRMED',
  },
  ARCHIVED: {
    key: 'ARCHIVED',
    label: 'ARCHIVED',
  },
  COMPROMISED: {
    key: 'COMPROMISED',
    label: 'COMPROMISED',
  },
  UNKNOWN: {
    key: 'UNKNOWN',
    label: 'UNKNOWN',
  },
  RESET_REQUIRED: {
    key: 'RESET_REQUIRED',
    label: 'RESET_REQUIRED',
  },
  FORCE_CHANGE_PASSWORD: {
    key: 'FORCE_CHANGE_PASSWORD',
    label: 'FORCE_CHANGE_PASSWORD',
  },
};